// Global ref for the shared "Cores das barras" modal (BarColorModal).
// Same pattern as symbolSpotlightRef / indicatorsPickerRef — the chart context
// menu and the navbar button both open the SAME modal instance without prop
// drilling. The context menu focuses the clicked chart before opening, so the
// modal's getSelectedChart() resolves to the right target.
export const barColorModalRef = { current: null };
